export default "__VITE_ASSET__BZwI6CUJ__"